import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';
import App from './App';
// import TagManager from 'react-gtm-module';

// const tagManagerArgs = {
//   // gtmId: 'GTM-KZPRHJF',
// };

// TagManager.initialize(tagManagerArgs);

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();
